/* Ten Antennas — cart drawer behaviour.

   POST-MORTEM, because the previous version of this file took the whole site
   down. Its observer re-applied the note rename on every mutation — but the
   rename ITSELF was a mutation: the match tested for 'order note' as well as
   'special instruction', so already-renamed text matched again, textContent
   was rewritten, the observer woke, and requestAnimationFrame ran the cycle
   again. An infinite loop at frame rate, main thread saturated, every click
   on every page dead.

   Two rules now make that impossible:
   • IDEMPOTENCE — both jobs check state first and write only when something
     actually needs to change. Re-running them on unchanged markup writes
     nothing, so no mutation, so no wake-up.
   • THE OBSERVER IS DISCONNECTED while apply() runs, so even a genuine write
     cannot echo back into the queue.

   The jobs themselves:
   1. The remove control belongs beside the item's NAME, but Dawn nests it in
      the quantity cell. Absolute positioning against the row failed — a <tr>
      turned grid item is not a containing block here and the button anchored
      to the viewport (measured at x=984 in a 976px window) — so the node is
      moved into the details block.
   2. "Order special instructions" becomes "Order notes".

   Both must survive Dawn re-rendering the drawer after every quantity change,
   hence the observer rather than a single run. */
(function () {
  if (window.__taCartDrawer) return;
  window.__taCartDrawer = true;

  var NOTE_LABEL = 'Order notes';
  var observer = null;
  var applying = false;

  function placeRemove(row) {
    var btn = row.querySelector('cart-remove-button');
    var details = row.querySelector('.cart-item__details');
    if (!btn || !details) return false;
    if (btn.parentElement === details) return false; /* already there */
    details.insertBefore(btn, details.firstChild);
    details.classList.add('ta-has-remove');
    return true;
  }

  function renameNote(root) {
    var changed = false;
    var targets = root.querySelectorAll('summary .summary__title, cart-note label, .cart__note label');
    Array.prototype.forEach.call(targets, function (el) {
      /* Only text nodes are touched — the caret svg inside stays. And only
         when the current text is NOT already the label: this comparison is
         what broke the site when it was missing. */
      Array.prototype.forEach.call(el.childNodes, function (n) {
        if (n.nodeType !== 3) return;
        var text = n.textContent.trim();
        if (!text) return;
        if (text === NOTE_LABEL) return;
        if (/special instruction/i.test(text) || /order note/i.test(text)) {
          n.textContent = NOTE_LABEL;
          changed = true;
        }
      });
    });
    return changed;
  }

  function apply() {
    if (applying) return;
    applying = true;
    if (observer) observer.disconnect();

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      Array.prototype.forEach.call(drawer.querySelectorAll('tr.cart-item'), placeRemove);
      renameNote(drawer);
    }

    if (observer && drawer) {
      observer.observe(drawer, { childList: true, subtree: true });
    }
    applying = false;
  }

  function start() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (!observer && 'MutationObserver' in window) {
      observer = new MutationObserver(function () {
        requestAnimationFrame(apply);
      });
    }
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  setTimeout(start, 900);
})();
